import { HALApiService } from './hal-api.service'
import { createItemsData } from '../utils/request.utils'
import { Service } from './base-service'

export const returnParcelsService = new Service('/storage/movements/return-parcel', HALApiService, createItemsData)
